import React, { useState } from 'react';
import styles from './FindIdEasyAuthPanel.module.css'; 
import axios from "../../../../utils/api/axios"; 
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

function FindIdEasyAuthPanel({ onNext }) {
    const [isEmailCodeSendError, setIsEmailCodeSendError] = useState(false);
    const [codeSendErrorText, setCodeSendErrorText] = useState('');
    const { showDialog } = useDialog();
    const maskEmail = (email) => {
        if (!email || email.indexOf('@') === -1) {
            return email;
        }

        const [localPart, domainPart] = email.split('@');
        let maskedLocalPart = '';

        const minLengthForFullMasking = 7;
        const revealPrefixFullMask = 3;
        const revealPrefixLongMask = 3;
        const revealSuffixLongMask = 2;

        if (localPart.length <= revealPrefixFullMask) {
            maskedLocalPart = localPart;
        } else if (localPart.length < minLengthForFullMasking) {
            const prefix = localPart.substring(0, revealPrefixFullMask);
            const maskedStars = '*'.repeat(localPart.length - revealPrefixFullMask);
            maskedLocalPart = `${prefix}${maskedStars}`;
        } else {
            const prefix = localPart.substring(0, revealPrefixLongMask);
            const suffix = localPart.substring(localPart.length - revealSuffixLongMask);
            const maskedStars = '*'.repeat(localPart.length - revealPrefixLongMask - revealSuffixLongMask);
            maskedLocalPart = `${prefix}${maskedStars}${suffix}`;
        }

        return `${maskedLocalPart}@${domainPart}`;
    };

    const handlePhoneVerify = () => {
        window.requestConnetxa.requestIndentifier()
            .then((identifier) => {
                if (identifier === "cancel") {
                    // showDialog(DialogEnum.DEFAULT, "취소", "사용자가 본인인증을 취소하였습니다.");
                    showDialog({
                        iconType: "warning",
                        type: 'error',
                        title: "오류",
                        message: "사용자가 본인인증을 취소하였습니다.",
                    });
                } else if (identifier === "fail") {
                    // showDialog(DialogEnum.FAIL, "실패", "본인인증 실패: 다시 시도해 주세요.");
                    showDialog({
                        iconType: "warning",
                        type: 'error',
                        title: "오류",
                        message: "본인인증 실패: 다시 시도해 주세요.",
                    });
                } else {
                    let verifiedCustomer = identifier.verifiedCustomer;
                    // 본인인증이 완료 된 후 사용자 전화 번호 업데이트 및 사용자 인증수단 업데이트 
                    // 이미 본인인증된 계정이 있는경우 확인 피룡

                    const now = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
                    let unifiedId = {};
                    //unifiedId 에서 인증 정보에 중복 인증 확인
                    let authInfo = {};
                    authInfo[now] = {
                        phone: [
                            {
                                value: verifiedCustomer.phoneNumber,
                                verification_status: "verified",
                                authentication_provider: "KG 이니시스",
                                ci: verifiedCustomer.ci || ""
                            }
                        ]
                    };

                    unifiedId = {
                        authInfo: authInfo
                    };

                    window.requestConnetxa.existUnifiedId(unifiedId)
                        .then(data => {
                            if (data && data.data) {
                                const maskedId = maskEmail(data.data.unifiedProfileId);
                                onNext(maskedId);
                            } else {
                                onNext('');
                            }
                        })
                        .catch(err => {
                            console.error("본인확인 오류", err); 
                            showDialog({
                                iconType: "warning",
                                type: 'error',
                                title: "오류",
                                message: "본인확인 오류가 발생했습니다.",
                            }); 
                        });
                }
            })
            .catch((err) => {
                console.error("❌ 인증 실패:", err);
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "오류",
                    message: "본인인증 중 오류가 발생했습니다.",
                });
            });
    };

    return (
        <>
            <div className={styles.signup_section}>
                <div className={styles.signup_title_row}>
                    <div className={`${styles.signup_title} innocode-typography--title-sm innocode-typography--bold`}>
                        아이디 찾기를 진행합니다.<br></br>간편인증을 진행해주세요
                    </div>
                </div>
                <div className={styles.signup_form_label_row}>
                    <div className={styles.signup_form_input_group}>
                        <InnocodeButton size={"lg"} type="submit" className={`${styles.send_code_btn}`} onClick={handlePhoneVerify}>
                            간편 본인인증
                        </InnocodeButton> 
                        {isEmailCodeSendError && (
                            <div className={styles.error_message}>{codeSendErrorText}</div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default FindIdEasyAuthPanel;
